<template>
    <transition name="loading-slide">
        <initial-loading-page v-if="!loaded"></initial-loading-page>
        <div v-else>
            <m-navbar :isWhiteLogo='false'></m-navbar>
            <div class="sidebar">
                <div @click="toggleSectionIndex(index)" v-for="(item,index) in sidebar" class="tab-name"
                     :class="{'tab-name-active':currentSectionIndex===index}">{{item}}
                </div>
            </div>
            <full-page :options="fullpageoptions" ref="fullpage">
                <div class="section">
                    <swiper :options="swiperOptionHome" ref="swiperHome" @slide-change="getHomeSlideIndex"
                            class="section-home">
                        <swiper-slide v-for="slide in home.slides">
                            <a :href="slide.url">
                                <img v-if="deviceRatio<2" class="home-slide-img"
                                     :src="baseUrl+slide.mobileBackground.url"
                                     alt="">
                                <img v-else class="home-slide-img" :src="baseUrl+slide.iphoneXBackground.url" alt="">
                            </a>
                        </swiper-slide>
                        <img v-show="currentHomeSlideIndex!==0" class="home-prev-slide-icon"
                             src="../assets/images/prev-slide-white-icon.png" alt=""
                             slot="button-prev">
                        <img v-show="currentHomeSlideIndex!==home.slides.length-1" class="home-next-slide-icon"
                             src="../assets/images/next-slide-white-icon.png" alt=""
                             slot="button-next">
                    </swiper>
                </div>
                <div class="section" v-for="(item,index) in swiperSectionsData">
                    <m-section-swiper :tabIndex="index+1" :slideIndex="item.slideIndex"
                                      :sectionData="item.sectionData" :routerName="item.routerName">
                    </m-section-swiper>
                </div>
                <div class="section">
                    <div class="contact-us">
                        <contact-us-info :is-mobile=true></contact-us-info>
                        <inquiry-form class="inquiry-form" width="100%" textareaHeight="2.26rem"></inquiry-form>
                    </div>
                </div>
            </full-page>
        </div>
    </transition>
</template>
<script>
    import MNavbar from '@/components/MNavbar.vue'
    import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import MSectionSwiper from '@/components/MSectionSwiper.vue'
    import {homeDataMixin} from '../mixins'
    import 'fullpage.js/dist/fullpage.css'

    export default {
        name: "MHome",
        components: {
            MNavbar,
            Swiper,
            SwiperSlide,
            MSectionSwiper
        },
        mixins: [homeDataMixin],
        beforeRouteEnter(to, from, next) {
            next(vm => {
                let slideIndex = parseInt(vm.$route.query.slideindex)
                const hash = location.hash.slice(1)
                if (from.name === 'productList' || hash === 'products') {
                    vm.productsSlide = slideIndex
                } else if (from.name === 'newsList' || hash === 'news') {
                    vm.newsSlide = slideIndex
                } else if (from.name === 'aboutUs' || hash === 'about-us') {
                    vm.aboutUsSlide = slideIndex
                }
            })
        },
        beforeRouteUpdate(to, from, next) {
            this.$refs.fullpage.api.moveTo(to.hash.slice(1))
            this.currentSectionIndex = this.fullpageoptions.anchors.findIndex(item => item === to.hash.slice(1))
            next()
        },
        created() {
            const fontSize = window.innerHeight / 11.36 + 'px'
            document.querySelector('html').style.fontSize = fontSize
        },
        data() {
            return {
                sidebar: ['HOME', 'PRODUCTS', 'NEWS', 'ABOUT US', 'CONTACT US'],
                fullpageoptions: {
                    anchors: ['home', 'products', 'news', 'about-us', 'contact-us'],
                    easingcss3: 'cubic-bezier(0.91, 0.03, 0.12, 1)',
                    scrollingSpeed: 1000,
                    onLeave: this.onLeave,
                    touchSensitivity: 15,
                },
                swiperOptionHome: {
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false
                    },
                    loop: true,
                    navigation: {
                        nextEl: '.home-next-slide-icon',
                        prevEl: '.home-prev-slide-icon',
                    }
                },
                currentSectionIndex: 0,
                currentHomeSlideIndex: 0,
                productsSlide: 0,
                newsSlide: 0,
                aboutUsSlide: 0,
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.$refs.fullpage.api.reBuild()
            })
        },
        computed: {
            swiperSectionsData() {
                return [
                    {
                        slideIndex: this.productsSlide,
                        sectionData: this.products,
                        routerName: 'productList'
                    },
                    {
                        slideIndex: this.newsSlide,
                        sectionData: this.news,
                        routerName: 'newsList'
                    },
                    {
                        slideIndex: this.aboutUsSlide,
                        sectionData: this.aboutUs,
                        routerName: 'aboutUs'
                    }
                ]
            }
        },
        methods: {
            getHomeSlideIndex() {
                this.currentHomeSlideIndex = this.$refs.swiperHome.$swiper.realIndex
            },
            toggleSectionIndex(index) {
                this.$refs.fullpage.api.moveTo(index + 1);
            },
            onLeave(origin, destination, direction) {
                this.currentSectionIndex = destination.index
            }
        },
        watch: {
            async showModal(val) {
                if (val) {
                    this.$refs.fullpage.api.destroy('all')
                } else {
                    await this.$nextTick()
                    this.$refs.fullpage.init()
                }
            }
        }
    }
</script>

<style scoped>
    .sidebar {
        position: absolute;
        left: 0;
        bottom: 196px;
        width: 53px;
        height: 731px;
        background-color: #00a496;
        border-radius: 0 35px 35px 0;
        padding-right: 18px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        z-index: 2;
    }

    .tab-name {
        transform: rotate(180deg);
        white-space: nowrap;
        font-size: 22px;
        writing-mode: vertical-lr;
        font-family: GOTHICB, sans-serif
    }

    .tab-name-active {
        color: white;
        border-right: 7px solid #9dc814;
    }

    .section >>> .swiper-wrapper {
        transition-duration: 1s !important;
        transition-timing-function: cubic-bezier(0.91, 0.03, 0.12, 1) !important;
    }

    .section-home {
        position: relative;
        width: 100vw;
        height: 1136px;
    }

    .home-next-slide-icon, .home-prev-slide-icon {
        position: absolute;
        z-index: 2;
        top: 0;
        bottom: 0;
        margin: auto 0;
    }

    .home-prev-slide-icon {
        left: 69px;
    }

    .home-next-slide-icon {
        right: 65px;
    }

    .home-slide-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }

    .contact-us {
        width: 70vw;
        height: 1136px;
        box-sizing: border-box;
        padding-top: 122px;
        margin: 0 auto;
    }

    .inquiry-form {
        margin-top: 18px;
    }

    .inquiry-form >>> .send-message {
        width: 66vw;
        height: 78px;
        font-size: 36px;
        margin: 41px auto;
    }

    .loading-slide-leave-active, .loading-slide-enter-active {
        transition: transform 1s cubic-bezier(0.91, 0.03, 0.12, 1);
    }

    .loading-slide-leave-to {
        transform: translate3d(0, 100vh, 0)
    }

    .loading-slide-enter {
        transform: translate3d(0, -100vh, 0);
    }

    .contact-us >>> .fp-tableCell {
        vertical-align: unset;
    }
</style>